export class ProjectFilterbarData {
    name: string;

    creatorName: string;

    category: string;

    status: string;
}
